module.exports = __webpack_public_path__ + "img/analysis_revise_rights.17334f15.svg";